import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UnitCallEventsFilters} from "../../../../units/models/unit-call-events-filters";
import {Device} from '../../../models/devices/device';
import {CallEventState} from "../../../../units/models/call-event";
import {LocalizerService} from "../../../services/localizer.service";

@Component({
    selector: 'app-call-event-filters',
    templateUrl: './call-event-filters.component.html',
    styleUrl: './call-event-filters.component.scss'
})
export class CallEventFiltersComponent {

    @Input() devices: Device[] = [];
    @Output() filtersChanged = new EventEmitter<UnitCallEventsFilters>();

    selectedDeviceId: string | null = null;
    selectedStatus: CallEventState | null = null;
    selectedDate: Date | null = null;

    readonly statusOptions = [
        {value: CallEventState.MISSED, label: this.localizer.getLocalizedString("Dashboard.MissedCallEvent")},
        {value: CallEventState.STARTED, label: this.localizer.getLocalizedString("Dashboard.ProgressCallEvent")},
        {value: CallEventState.ANSWERED, label: this.localizer.getLocalizedString("Dashboard.AnsweredCallEvent")},
        {value: CallEventState.CANCELLED, label: this.localizer.getLocalizedString("Dashboard.CancelledCallEvent")},
        {value: CallEventState.REJECTED, label: this.localizer.getLocalizedString("Dashboard.RefusedCallEvent")},
        {value: CallEventState.FORWARDED, label: this.localizer.getLocalizedString("Dashboard.ForwardedCallEvent")},
        {value: CallEventState.BRIDGED, label: this.localizer.getLocalizedString("Dashboard.BridgedCallEvent")}
    ];

    constructor(public localizer: LocalizerService) {
    }

    onDeviceChange(deviceId: string | null) {
        this.selectedDeviceId = deviceId;
        this.emitFilters();
    }

    onStatusChange(status: CallEventState | null) {
        this.selectedStatus = status;
        this.emitFilters();
    }

    onDateChange(date: Date) {
        this.selectedDate = date;
        this.emitFilters();
    }

    private emitFilters() {
        this.filtersChanged.emit({
            DeviceId: this.selectedDeviceId || undefined,
            Status: this.selectedStatus || undefined,
            Date: this.selectedDate || undefined
        });
    }
}
